<template>
    <div class="global-address-administration__delete">
        <div class="row">
            <div class="col-12 col-md-4">
                <global-address :address="affectedAddress" />
            </div>
        </div>
    </div>
</template>

<script>
import GlobalAddress from "@global/global-elements/global-address/global-address";
export default {
    name: "global-address-administration-delete",
    components: {GlobalAddress},
    props: ["affectedAddress", "addresses"]
}
</script>
